import styles from './alert.module.css';
import { ALERT_ANIMATIONS, type AlertAnimation } from './alert.enum';

export const animationClassMap: Record<AlertAnimation, string> = {
    [ALERT_ANIMATIONS.FADE]: styles.animationFade,
    [ALERT_ANIMATIONS.SLIDE_DOWN]: styles.animationSlideDown,
    [ALERT_ANIMATIONS.SLIDE_UP]: styles.animationSlideUp,
    [ALERT_ANIMATIONS.SLIDE_LEFT]: styles.animationSlideLeft,
    [ALERT_ANIMATIONS.SLIDE_RIGHT]: styles.animationSlideRight,
    [ALERT_ANIMATIONS.ZOOM]: styles.animationZoom,
    [ALERT_ANIMATIONS.BOUNCE]: styles.animationBounce,
    [ALERT_ANIMATIONS.FLIP]: styles.animationFlip,
};
